import { useAtomValue } from "jotai";
import { addToast } from "../../components/Toast";
import { syncStateAtom } from "../atoms";
import { computeSyncStatus } from "./SyncStatus";
import { useSyncStatsReactions } from "./useSyncStatusReactions";

const SyncStatusIcon = () => {
  const syncState = useAtomValue(syncStateAtom);
  const status = computeSyncStatus();
  useSyncStatsReactions();

  // Render the sync status icon
  const { appNoteCount, serverNoteCount } = syncState;
  const tooltipMessage = [
    status.message,
    `Type: ${status.id}`,
    [`client count: ${appNoteCount || "unknown"}`, `server count: ${serverNoteCount || "unknown"}`].join(", "),
  ].join("\n");
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onTouchStart={() => {
        addToast({
          content: tooltipMessage,
          type: "info",
        });
      }}
    >
      <div
        role="tooltip"
        data-microtip-position="bottom-left"
        aria-label={tooltipMessage}
        className={`sync-icon ${status.id}`}
        style={{
          position: "relative",
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: status.color,
          transition: "background-color 0.3s ease",
          margin: "0px 8px",
        }}
      >
        &nbsp;
      </div>
    </div>
  );
};

export default SyncStatusIcon;
